import { cn } from '@/lib/utils';

/**
 * Feed navigation icon. Colors via `currentColor` so the parent's text
 * color (and `transition-colors`) drives the active/inactive animation.
 *
 * Cropped from the exported asset to the glyph bounds — the original
 * shipped inside a 90×84 tab frame with a baked-in top divider.
 *
 * @param active - When `true`, plays the "stagger rise" animation: the left
 *   wing, arrow, and right wing each lift and settle in sequence (keyframes in
 *   `index.css`, keyed on the `data-active` attribute).
 */
export function FeedIcon({ active, className, ...props }: React.SVGProps<SVGSVGElement> & { active?: boolean }) {
  return (
    <svg
      viewBox="28 26 34 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('nav-icon nav-icon--feed', className)}
      data-active={active ? 'true' : undefined}
      {...props}
    >
      <path
        className="nav-feed-arrow"
        d="M49.5795 34.9751L47.0576 35.7615C46.9865 35.7821 46.9351 35.8521 46.9272 35.9304C46.0062 47.8463 34.3692 49.3163 34.3099 49.3245L33.9897 48.2828C42.5514 45.6188 42.5475 37.3756 42.4131 35.9262C42.4052 35.848 42.3538 35.7821 42.2787 35.7615L39.496 34.971L44.4013 27.5348C44.4251 27.4896 44.4685 27.4648 44.512 27.4566C44.5713 27.4484 44.6306 27.4731 44.6662 27.5348L49.5795 34.971V34.9751Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.401473"
        strokeMiterlimit="10"
      />
      <path
        className="nav-feed-wing-left"
        d="M33.4394 46.523L29.3799 33.4665C34.1548 32.7418 37.6451 36.7522 37.6451 36.7522C36.2577 37.2546 35.2616 38.6257 35.2616 40.2438C35.2616 41.862 36.3407 43.3484 37.8151 43.7972C37.8151 43.7972 36.4751 45.8189 33.4433 46.523H33.4394Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.401473"
        strokeMiterlimit="10"
      />
      <path
        className="nav-feed-wing-right"
        d="M52.8164 36.7563C54.2039 37.2587 55.2 38.6298 55.2 40.248C55.2 42.2902 53.6109 43.9496 51.6464 43.9496C49.6819 43.9496 48.0929 42.2943 48.0929 40.248C48.0929 40.1368 48.1008 40.0256 48.1087 39.9186C47.5711 42.2408 44.6698 49.3311 34.7246 50.7104C34.7246 50.7104 34.7286 50.7269 34.7286 50.731L55.7059 50.7516L61.0738 33.4665C56.2988 32.7418 52.8085 36.7522 52.8085 36.7522L52.8164 36.7563Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.401473"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
